import script from "./codeCheck.vue?vue&type=script&setup=true&lang=ts"
export * from "./codeCheck.vue?vue&type=script&setup=true&lang=ts"

import "./codeCheck.vue?vue&type=style&index=0&id=11d9a3ac&lang=less"

const __exports__ = script;

export default __exports__